const pirateDictionary = [
    // Expressions (Greetings, Exclamations, Commands, Affirmations, Negations)
    { slang: "Ahoy", meaning: "Hello, a loud shout to friends", kind: "Expression" },
    { slang: "Arrr", meaning: "A growl when mad or feeling pirate-y", kind: "Expression" },
    { slang: "Avast ye!", meaning: "Stop right now, you sea dogs!", kind: "Expression" },
    { slang: "Blimey", meaning: "Wow, I can’t believe it!", kind: "Expression" },
    { slang: "Shiver me timbers", meaning: "I’m shocked or amazed!", kind: "Expression" },
    { slang: "Thar she blows", meaning: "Look, there it is!", kind: "Expression" },
    { slang: "Land ho!", meaning: "I see land ahead!", kind: "Expression" },
    { slang: "Aye aye, Cap’n", meaning: "Yes, Captain, I agree!", kind: "Expression" },
    { slang: "Nay", meaning: "No, you fool!", kind: "Expression" },
    { slang: "Heave ho", meaning: "Pull hard, everyone!", kind: "Expression" },
    { slang: "Dead men tell no tales", meaning: "Keep secrets by silencing enemies", kind: "Expression" },
    { slang: "Yo-ho-ho", meaning: "A happy pirate cheer", kind: "Expression" },
    { slang: "Blow me down", meaning: "I’m so surprised I could fall over!", kind: "Expression" },
    { slang: "Sink me!", meaning: "Oh no, I’m upset!", kind: "Expression" },
    { slang: "Batten down the hatches", meaning: "Get ready for trouble!", kind: "Expression" },
    { slang: "By Davy Jones!", meaning: "I swear by the sea monster!", kind: "Expression" },
    { slang: "Huzzah!", meaning: "A loud cheer for victory!", kind: "Expression" },
    { slang: "Ye", meaning: "You, said the pirate way", kind: "Expression" },
    { slang: "Matey", meaning: "Hey, friend on the ship!", kind: "Expression" },

    // Insults
    { slang: "Bilge rat", meaning: "A smelly jerk from the ship’s bottom", kind: "Insult" },
    { slang: "Scallywag", meaning: "A sneaky, no-good pirate", kind: "Insult" },
    { slang: "Landlubber", meaning: "A clumsy person bad at sailing", kind: "Insult" },
    { slang: "Lily-livered", meaning: "A scaredy-cat with no guts", kind: "Insult" },
    { slang: "Shark bait", meaning: "A weakling the fish would eat", kind: "Insult" },
    { slang: "Swab", meaning: "A lowly cleaner, totally useless", kind: "Insult" },
    { slang: "Scurvy dog", meaning: "A dirty, sick mutt", kind: "Insult" },
    { slang: "Blaggard", meaning: "A bad guy with no honor", kind: "Insult" },
    { slang: "Barnacle-brained", meaning: "A dumb person with a crusty head", kind: "Insult" },
    { slang: "Dog-hearted", meaning: "A mean jerk with no kindness", kind: "Insult" },
    { slang: "Yellow-bellied", meaning: "A coward afraid of everything", kind: "Insult" },
    { slang: "Rum-soaked", meaning: "A drunk who’s good for nothing", kind: "Insult" },
    { slang: "Lubberwort", meaning: "A sickly, goofy land-dweller", kind: "Insult" },
    { slang: "Poxy whelp", meaning: "A whiny kid full of sores", kind: "Insult" },
    { slang: "Squiffy swab", meaning: "A tipsy cleaner who messes up", kind: "Insult" },
    { slang: "Son of a biscuit eater", meaning: "Kid of a weak coward", kind: "Insult" },
    { slang: "Gizzard-gutted", meaning: "A fat, lazy slug", kind: "Insult" },
    { slang: "Sea-addled", meaning: "Confused from too much sea", kind: "Insult" },
    { slang: "Craven codfish", meaning: "A spineless, smelly fish", kind: "Insult" },
    { slang: "Brine-bloated", meaning: "A soggy, slow fool", kind: "Insult" },
    { slang: "Mewling tarpaulin", meaning: "A crybaby with no toughness", kind: "Insult" },
    { slang: "Grog-blossom", meaning: "A drunk with a red face", kind: "Insult" },

    // Objects
    { slang: "Booty", meaning: "Stolen treasure and gold", kind: "Object" },
    { slang: "Grog", meaning: "Rum and water, pirate’s drink", kind: "Object" },
    { slang: "Cutlass", meaning: "A short sword for fighting", kind: "Object" },
    { slang: "Jolly Roger", meaning: "Pirate flag with a skull", kind: "Object" },
    { slang: "Coffer", meaning: "A box for storing loot", kind: "Object" },
    { slang: "Pieces of Eight", meaning: "Old Spanish silver coins", kind: "Object" },
    { slang: "Crow’s Nest", meaning: "A high lookout spot", kind: "Object" },
    { slang: "Black spot", meaning: "A sign of death or trouble", kind: "Object" },
    { slang: "Doubloon", meaning: "A shiny gold coin", kind: "Object" },
    { slang: "Peg leg", meaning: "A wooden leg for a hurt pirate", kind: "Object" },
    { slang: "Spyglass", meaning: "A tool to see far away", kind: "Object" },
    { slang: "Cannon", meaning: "A big gun that shoots", kind: "Object" },
    { slang: "Gibbet", meaning: "A cage for punishing bad guys", kind: "Object" },
    { slang: "Bilge", meaning: "Dirty water in the ship", kind: "Object" },
    { slang: "Barnacles", meaning: "Little bugs stuck to the ship", kind: "Object" },
    { slang: "Sea", meaning: "The big, wild ocean", kind: "Object" },

    // Actions
    { slang: "Hornswaggle", meaning: "Cheat someone with a grin", kind: "Action" },
    { slang: "Walk the plank", meaning: "Make someone jump into the sea", kind: "Action" },
    { slang: "Keelhaul", meaning: "Drag someone under the ship", kind: "Action" },
    { slang: "Maroon", meaning: "Leave someone on an island", kind: "Action" },
    { slang: "Plunder", meaning: "Steal stuff with swords", kind: "Action" },
    { slang: "Mutiny", meaning: "Fight against the captain", kind: "Action" },
    { slang: "Parley", meaning: "Talk peace with an enemy", kind: "Action" },
    { slang: "Crack Jenny’s teacup", meaning: "Survive a big storm", kind: "Action" },
    { slang: "Run a shot across the bow", meaning: "Fire a warning shot", kind: "Action" },
    { slang: "Scuttle", meaning: "Sink your own ship", kind: "Action" },
    { slang: "Splice the mainbrace", meaning: "Give everyone rum", kind: "Action" },
    { slang: "Board", meaning: "Attack another ship", kind: "Action" },
    { slang: "Flog", meaning: "Whip someone hard", kind: "Action" },
    { slang: "Swig", meaning: "Drink rum fast", kind: "Action" },

    // Adjectives
    { slang: "Poxy", meaning: "Sick or awful", kind: "Adjective" },
    { slang: "Briny", meaning: "Salty from the sea", kind: "Adjective" },
    { slang: "Foul", meaning: "Bad or smelly", kind: "Adjective" },
    { slang: "Rusty", meaning: "Old and worn out", kind: "Adjective" },
    { slang: "Squinting", meaning: "Can’t see well or sneaky", kind: "Adjective" },
    { slang: "Mangled", meaning: "All busted up", kind: "Adjective" },
    { slang: "Sodden", meaning: "Soaked and heavy", kind: "Adjective" },
    { slang: "Gnarled", meaning: "Rough and beat-up", kind: "Adjective" },
    { slang: "Stinking", meaning: "Really smelly", kind: "Adjective" },
    { slang: "Withered", meaning: "Weak and dried out", kind: "Adjective" },
    { slang: "Crusty", meaning: "Hard and rough", kind: "Adjective" },
    { slang: "Bloody", meaning: "Bad or covered in blood", kind: "Adjective" },
    { slang: "Treacherous", meaning: "Sneaky and dangerous", kind: "Adjective" },
    { slang: "Weevil-ridden", meaning: "Full of bugs and ruined", kind: "Adjective" },
    { slang: "Blasted", meaning: "Broken or cursed", kind: "Adjective" },
];

export default pirateDictionary;